import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { PropertyProviderModel } from '../models/property-provider.model';
import { PropertyProvidersService } from '../services/property-providers.service';

@Injectable()
export class PropertyProviderResolver implements Resolve<PropertyProviderModel> {

    constructor(private service: PropertyProvidersService) 
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<PropertyProviderModel> {
        return this.service.GetProvider(route.params.property_provider_id);
    }
}
